// extracted by mini-css-extract-plugin
export default {"table":"Notice_table__JzC+5","container":"Notice_container__LkXyt"};